<!-- used in /site/1/summary -->

<h3>Roles for "{{title}}"</h3>

<div *ngIf="roles==null || roles.length==0">Loading Roles...</div>
<div *ngIf="roles != null && folderView()" class="inheritance-buttons">
    <div style="display:none">
        <!-- this is here for now for debug -->
        <br />membersAreInherited={{rolesWrapper.membersAreInherited}}
        <br />membersAreInheritedFromSiteLevel={{rolesWrapper.membersAreInheritedFromSiteLevel}}
    </div>
    <div *ngIf="membersAreInherited">
        <div *ngIf="rolesWrapper.folderFromWhichRolesAreInherited != null" class="inheritance-message">Role members for this folder are inherited from ancestor folder "{{rolesWrapper.folderFromWhichRolesAreInherited.name}}"</div>
        <div *ngIf="rolesWrapper.membersAreInheritedFromSiteLevel" class="inheritance-message">Role members for this folder are inherited from the Site-level. Select the "Stop Inheriting Permissions" button to apply folder specific permissions.</div>
        <button mat-flat-button
                matTooltip="{{getInheritanceTooltip()}}"
                color="primary"
                [ngClass]="enableInheritanceControlButton ? 'theme-primary-btn' : 'theme-primary-btn[disabled]'"
                (click)="toggleInheritance()">
            Stop Inheriting Permissions
        </button>
    </div>
    <div *ngIf="!membersAreInherited">
        <div class="roles-not-inherited inheritance-message">This folder has explicit role members that are not inherited from its parent. Role members for this folder are managed here.<br /></div>
        <button mat-flat-button
                matTooltip="{{getInheritanceTooltip()}}"
                color="primary"
                [ngClass]="enableInheritanceControlButton ? 'theme-primary-btn' : 'theme-primary-btn[disabled]'"
                (click)="toggleInheritance()">
            Inherit Permissions
        </button>
    </div>
</div>
<!-- Candidate for refactoring into a re-usable component-->
<mat-accordion>
    <!-- DISPLAY SITE LEVEL ROLES -->
    <div class="roles" *ngIf="adminView()">
        <div>
            <strong>Site-Level Roles</strong><br />
            Automatically applied to all folder levels of the tree
        </div>
        <mat-expansion-panel *ngFor="let role of SiteLevelRoles" [hideToggle]="role.memberCount() == 0">
            <mat-expansion-panel-header>
                <mat-panel-title [ngClass]="{'greyed-out':membersAreInherited}">
                    <div class="role-title">
                        <strong>
                            {{role.name}} ({{role.memberCount()}})
                        </strong>
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon (click)="openRoleDialog({event:$event, entityName:title, role:role})"
                              (keyup.enter)="openRoleDialog({event:$event, entityName:title, role:role})"
                              matTooltip="{{getTitleForManageRolesIcon()}}"
                              tabindex="0"
                              [ngClass]="{'greyed-out':membersAreInherited || !role.canGrant}">person_add</mat-icon>
                    &nbsp;
                    <mat-icon *ngIf="adminView()"
                              (click)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                              tabindex="0"
                              (keyup.enter)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                              title="Edit Role Details">edit</mat-icon>
                    <mat-icon *ngIf="adminView() && role.memberCount() == 0"
                              (click)="deleteRole($event, role)"
                              tabindex="1"
                              (keyup.enter)="deleteRole($event, role)"
                              title="Delete Role">delete</mat-icon>
                    <mat-icon *ngIf="adminView() && role.memberCount() > 0"
                              tabindex="1"
                              class="greyed-out"
                              matTooltip="You cannot delete roles with members. To delete this role, first delete its members">delete</mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
                <div *ngFor="let member of role.members" class="role-member" [ngClass]="{'greyed-out':membersAreInherited}">
                    <span *ngIf="member.selected">{{member.member}}</span>
                </div>
            </div>
        </mat-expansion-panel>
    </div>

    <!-- DISPLAY FOLDER-LEVEL ROLES (Only display roles inherited from an ancestor Folder)-->
    <div class="roles" *ngIf="FolderIsManagingOwnRolesOrInheritingFromAncestor">
        <div *ngIf="adminView()">
            <strong>Folder-Level Roles</strong><br />
            Take effect only when applied to Folders
        </div>
        <mat-expansion-panel *ngFor="let role of FolderLevelRoles" [hideToggle]="role.memberCount() == 0">
            <mat-expansion-panel-header>
                <mat-panel-title [ngClass]="{'greyed-out':membersAreInherited}">
                    <div class="role-title">
                        <strong>
                            {{role.name}} ({{role.memberCount()}})
                        </strong>
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon (click)="openRoleDialog({event:$event, entityName:title, role:role})"
                              (keyup.enter)="openRoleDialog({event:$event, entityName:title, role:role})"
                              matTooltip="{{getTitleForManageRolesIcon()}}"
                              tabindex="0"
                              [ngClass]="{'greyed-out':membersAreInherited || !role.canGrant}">person_add</mat-icon>
                    &nbsp;
                    <mat-icon *ngIf="adminView()"
                              (click)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                              tabindex="0"
                              (keyup.enter)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                              title="Edit Role Details">edit</mat-icon>
                    <mat-icon *ngIf="adminView() && role.memberCount() == 0"
                              (click)="deleteRole($event, role)"
                              tabindex="1"
                              (keyup.enter)="deleteRole($event, role)"
                              title="Delete Role">delete</mat-icon>
                    <mat-icon *ngIf="adminView() && role.memberCount() > 0"
                              tabindex="1"
                              class="greyed-out"
                              matTooltip="You cannot delete roles with members. To delete this role, first delete its members">delete</mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
                <div *ngFor="let member of role.members" class="role-member" [ngClass]="{'greyed-out':membersAreInherited}">
                    <span *ngIf="member.selected">{{member.member}}</span>
                </div>
            </div>
        </mat-expansion-panel>
    </div>
</mat-accordion>

<button *ngIf="adminView()" class="new-role-btn theme-primary-btn" mat-flat-button color="primary" (click)="openCreateRoleDialog()">New Role</button>
